
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 9 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.04 1.415a2.27 2.27 0 0 0 0 3.208L4.476 8.06l.024-.023.024.023L7.96 4.623a2.269 2.269 0 0 0-3.208-3.208.356.356 0 0 1-.504 0 2.27 2.27 0 0 0-3.208 0","fill":"#fff"}})])
          )
        }
      }
    